import { useMemo, useState } from 'react'
import Avatar from '@mui/material/Avatar'

import { API_BASE } from '@/config/api'
import { colorFromString, getInitials } from './userMeta'

/**
 * Avatar that fetches /api/users/:id/avatar and falls back to colored initials.
 *
 * Props:
 *  - user: the user object (must have tid, fullName/userName and optionally avatarUrl)
 *  - size: pixel size (default 40)
 *  - cacheBust: optional value to force reload after upload
 */
const UserAvatar = ({ user, size = 40, cacheBust, sx }) => {
    const [errored, setErrored] = useState(false)
    const initials = useMemo(() => getInitials(user?.fullName, user?.userName), [user])
    const bg = useMemo(() => colorFromString(user?.userName || user?.fullName || ''), [user])

    const showImage = Boolean(user?.tid && user?.avatarUrl) && !errored

    const src = showImage
        ? `${API_BASE}/users/${user.tid}/avatar${cacheBust ? `?t=${cacheBust}` : ''}`
        : undefined

    return (
        <Avatar
            src={src}
            slotProps={{ img: { onError: () => setErrored(true) } }}
            sx={{
                width: size,
                height: size,
                bgcolor: showImage ? 'grey.300' : bg,
                color: '#fff',
                fontWeight: 600,
                fontSize: size * 0.38,
                ...sx
            }}>
            {!showImage && initials}
        </Avatar>
    )
}

export default UserAvatar
